import BaseLayout from 'layout/base-layout/BaseLayout';
import Caixa from 'pages/Caixa/Caixa';
import Configuracoes from 'pages/Configuracoes/Configuracoes';
import RelatorioFechamento from 'pages/RelatorioFechamento/RelatorioFechamento';
import Venda from 'pages/Venda/Venda';
import Conferencia from 'pages/conferencia/Conferencia';
import ConsignadoDetail from 'pages/consignado/detail/ConsignadoDetail';
import ConsignadoDevolucao from 'pages/consignado/devolucao/ConsignadoDevolucao';
import ConsignadoList from 'pages/consignado/list/ConsignadoList';
import Financas from 'pages/financas/Financas';
import FinancasGestaoReceber from 'pages/financas/FinancasGestaoReceber';
import Login from 'pages/login/login';
import Pagamento from 'pages/pagamento/pagamento';
import ValePresenteBuscaAvancada from 'pages/vale-presente/ValePresenteBuscaAvancada';
import ValePresenteTelaPagamento from 'pages/vale-presente/ValePresenteTelaPagamento';
import { Navigate, createBrowserRouter } from 'react-router-dom';
import { ALL_FLOW_ROLES, ROLES } from 'roles/roles';
import Guard from './auth/Guard';
import RegistraVenda from './pages/registra-venda/registra-venda';

export const router = createBrowserRouter([
    {
        path: '/',
        element: (
            <Guard allowedRoles={ALL_FLOW_ROLES}>
                <BaseLayout />
            </Guard>
        ),
        children: [
            {
                path: '',
                index: true,
                element: (
                    <Navigate
                        replace={true}
                        to={{ pathname: '/caixa' }}
                    />
                ),
            },
            { path: 'home', element: <></> },
            {
                path: 'registra-venda',
                element: (
                    <Guard
                        allowedRoles={[ROLES.VENDA]}
                        label='PDV'>
                        <RegistraVenda key='registra-venda' />
                    </Guard>
                ),
            },
            {
                path: 'pagamento',
                element: (
                    <Guard
                        allowedRoles={[ROLES.VENDA]}
                        label='Pagamento'>
                        <Pagamento />
                    </Guard>
                ),
            },
            {
                path: 'caixa',
                element: (
                    <Guard
                        allowedRoles={[ROLES.CAIXA]}
                        label='Caixa'>
                        <Caixa />
                    </Guard>
                ),
            },
            {
                path: 'venda',
                element: (
                    <Guard
                        allowedRoles={[ROLES.VENDA]}
                        label='Vendas'>
                        <Venda />
                    </Guard>
                ),
            },
            { path: 'configuracoes', element: <Configuracoes /> },
            { path: 'relatorio/caixa/fechamento', element: <RelatorioFechamento /> },
            {
                path: 'vale-presente',
                element: (
                    <Guard
                        allowedRoles={[ROLES.VENDA]}
                        label='Vale Presente'>
                        <ValePresenteTelaPagamento />
                    </Guard>
                ),
            },
            { path: 'vale-presente/busca-avancada', element: <ValePresenteBuscaAvancada /> },
            {
                path: 'pre-venda',
                element: (
                    <Guard
                        allowedRoles={[ROLES.PRE_VENDA]}
                        label='Pré-venda'>
                        <RegistraVenda key='pre-venda' />
                    </Guard>
                ),
            },
            {
                path: 'conferencia/:uuid',
                element: (
                    <Guard
                        allowedRoles={[ROLES.VENDA]}
                        label='Conferência'>
                        <Conferencia />
                    </Guard>
                ),
            },
            {
                path: 'financas',
                element: (
                    <Guard
                        allowedRoles={[ROLES.CONTA_RECEBER]}
                        label='Finanças'>
                        <Financas key='finanças' />
                    </Guard>
                ),
            },
            {
                path: 'financas/gestao-receber',
                element: (
                    <Guard
                        allowedRoles={[ROLES.CONTA_RECEBER]}
                        label='Finanças - Gestão a Receber'>
                        <FinancasGestaoReceber key='financas-gestao-receber' />
                    </Guard>
                ),
            },
            {
                path: 'registra-consignado',
                element: (
                    <Guard
                        allowedRoles={[ROLES.CONSIGNADO]}
                        label='Consignado'>
                        <ConsignadoDetail />
                    </Guard>
                ),
            },
            {
                path: 'consignado',
                element: (
                    <Guard
                        allowedRoles={[ROLES.CONSIGNADO]}
                        label='Consignado'>
                        <ConsignadoList />
                    </Guard>
                ),
            },
            {
                path: 'devolucao-consignado',
                element: (
                    <Guard
                        allowedRoles={[ROLES.CONSIGNADO]}
                        label='Devolução de Consignado'>
                        <ConsignadoDevolucao />
                    </Guard>
                ),
            },
        ],
    },
    { path: 'login', element: <Login /> },
]);
